module.exports = __webpack_public_path__ + "img/login_bg.2e351b66.png";